import { useEffect, useState } from "react";
import type { DrupalArticleDataObject } from "@app/types/Drupal";
import { DRUPAL_API_ENDPOINT, DRUPAL_API_KEY } from "@util/constant";
import axios from "axios";

export type MostReadResponse = {
  total: number;
  results: DrupalArticleDataObject[];
};

const fetchMostReadArticles = async (): Promise<DrupalArticleDataObject[]> => {
  if (!DRUPAL_API_ENDPOINT || !DRUPAL_API_KEY) return [];
  try {
    const response = await axios.get<MostReadResponse>(
      "/_plat/api/v1/most-popular"
    );
    return response.data.results ?? [];
  } catch (e) {
    return [];
  }
};

/**
 * Description: It returns GA enabled most popular article list from Drupal API
 * @returns data - {DrupalArticleDataObject[]}
 */
export default function useMostReadArticleList(): DrupalArticleDataObject[] {
  const [data, setData] = useState<DrupalArticleDataObject[]>([]);
  useEffect(() => {
    const callFetch = async () => {
      setData(await fetchMostReadArticles());
    };
    callFetch();
  }, []);

  return data;
}
